export default [
  {
    path: 'novo-contraches',
    name: 'new-employee-paycheck',
    component: () => import('./new-paycheck.vue'),
    meta: {
      pageSection: 'Funcionários',
      pageTitle: 'Contracheques',
      auth: true,
      user: 'Admin',
    },
  },
]
